import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateTuitionPaymentOptionsMutation = graphql.persisted(
  "UpdateTuitionPaymentOptions",
  graphql(`
    mutation UpdateTuitionPaymentOptions($input: UpdateTuitionPaymentOptionsInput!) {
      updateTuitionPaymentOptions(input: $input) {
        paymentOptions {
          key
          name
          description
          scheduleType
          billingDayOfMonth
          discountCents
          discountType
          appliesTo
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateTuitionPaymentOptionsMutation };

export function useUpdateTuitionPaymentOptions() {
  return useMutation(UpdateTuitionPaymentOptionsMutation);
}
